import { render, staticRenderFns } from "./OneDateOfCatalogJg.vue?vue&type=template&id=d4990d46"
import script from "./OneDateOfCatalogJg.vue?vue&type=script&lang=js"
export * from "./OneDateOfCatalogJg.vue?vue&type=script&lang=js"
import style0 from "./OneDateOfCatalogJg.vue?vue&type=style&index=0&id=d4990d46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports